import ScreenPaymentList from 'screens/Payment/List';
import ScreenPaymentDetails from 'screens/Payment/Details';
import { PAYMENT } from 'routes/paths';

const paymentRoutes = [
  {
    path: PAYMENT.LIST,
    name: 'PaymentList',
    component: ScreenPaymentList,
    loginRequired: true,
    allowPermissions: ['list_payment'],
  },
  {
    path: PAYMENT.DETAILS,
    name: 'PaymentDetails',
    component: ScreenPaymentDetails,
    loginRequired: true,
    allowPermissions: ['view_payment'],
  },
];

export default paymentRoutes;
